import React, { Component } from 'react';
import regla from '../../../images/pdf/Reglement Constructeursregister  RCRO 1.0   - kwaliteitsregister.pdf'
import statuten from '../../../images/pdf/statuten Stichting CR.pdf'
class Reglamenten extends Component {

  render() {
    return (
      <div className="route">
        <div>
          <h1 className="pageTitle">
            Reglementen RC/RO/RT
          </h1>
        </div>
        <div>
          Download de <a href={statuten}>statuten</a> en de <a href={regla}>reglementen</a> van de stichting Constructeursregister
        </div>
      </div>
    );
  }
}

export default Reglamenten;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Reglamenten.js